import reducer from "./reducers";

import * as labtestAction from "./actions";

export { labtestAction };

export default reducer;
